<template>
  <div class="contact">
    <div class="banner" :style="{ background: 'linear-gradient(120deg, #E0EAF4, #B5C8DC)' }">
      <div class="container">
        <div class="banner-content">
          <h1>联系我们</h1>
          <p>随时随地，为您提供专业支持</p>
        </div>
      </div>
    </div>

    <div class="section">
      <div class="container">
        <el-row :gutter="30">
          <el-col :xs="24" :sm="24" :md="10">
            <div class="contact-info">
              <h2>联系方式</h2>
              <p class="contact-desc">
                如果您对我们的产品或服务有任何疑问，欢迎通过以下方式与我们联系，我们将尽快回复您的咨询。
              </p>

              <div class="contact-item">
                <i class="el-icon-location"></i>
                <div>
                  <h3>公司地址</h3>
                  <p>上海市嘉定区德富路1090号宝龙广场5号楼502室</p>
                </div>
              </div>

              <div class="contact-item">
                <i class="el-icon-phone"></i>
                <div>
                  <h3>客服热线</h3>
                  <p>13671549886</p>
                </div>
              </div>

              <div class="contact-item">
                <i class="el-icon-message"></i>
                <div>
                  <h3>电子邮箱</h3>
                  <p>contact@schoolsoft.cn</p>
                </div>
              </div>

              <div class="contact-item">
                <i class="el-icon-time"></i>
                <div>
                  <h3>工作时间</h3>
                  <p>周一至周五: 9:00 - 18:00</p>
                </div>
              </div>

              <div class="social-links">
                <h3>关注我们</h3>
                <div class="social-icons">
                  <a href="#" class="social-icon">
                    <i class="el-icon-s-platform"></i>
                  </a>
                  <a href="#" class="social-icon">
                    <i class="el-icon-s-promotion"></i>
                  </a>
                  <a href="#" class="social-icon">
                    <i class="el-icon-s-marketing"></i>
                  </a>
                </div>
              </div>
            </div>
          </el-col>

          <el-col :xs="24" :sm="24" :md="14">
            <contact-form
              title="在线咨询"
              description="填写以下表单，我们的专业团队将尽快与您联系。"
              @submit-success="handleSubmitSuccess"
            />
          </el-col>
        </el-row>
      </div>
    </div>

    <div class="section bg-light">
      <div class="container">
        <h2 class="section-title">公司位置</h2>
        <div class="map-container">
          <div class="map-placeholder">
            <i class="el-icon-map-location"></i>
            <p>公司地址：上海市嘉定区德富路1090号宝龙广场5号楼502室</p>
          </div>
        </div>
      </div>
    </div>

    <div class="section">
      <div class="container">
        <h2 class="section-title">常见问题</h2>
        <p class="section-subtitle">以下是我们的客户经常咨询的问题，希望对您有所帮助</p>

        <el-collapse accordion>
          <el-collapse-item title="1. 如何选择适合我们机构的产品？" name="1">
            <div>
              我们会根据您机构的具体需求和规模，为您推荐最适合的产品和解决方案。您可以通过在线咨询或致电客服热线，我们的专业顾问将为您提供一对一的咨询服务。
            </div>
          </el-collapse-item>
          <el-collapse-item title="2. 产品实施周期一般是多久？" name="2">
            <div>
              根据项目复杂度和规模不同，实施周期也有所差异。一般小型项目1-2个月即可完成，中大型项目可能需要3-6个月。我们会在项目启动前提供详细的实施计划和时间表。
            </div>
          </el-collapse-item>
          <el-collapse-item title="3. 是否提供产品培训服务？" name="3">
            <div>
              是的，我们为每个客户提供系统化的产品培训服务，包括系统操作培训、管理员培训等，确保您的团队能够熟练使用我们的产品。
            </div>
          </el-collapse-item>
          <el-collapse-item title="4. 售后支持服务如何？" name="4">
            <div>
              我们提供7x24小时技术支持服务，您可以通过电话、邮件或在线客服获取帮助。我们承诺对重大问题2小时响应，一般问题24小时内解决。
            </div>
          </el-collapse-item>
          <el-collapse-item title="5. 是否可以定制开发？" name="5">
            <div>
              是的，我们可以根据客户的特殊需求提供定制开发服务。我们的专业团队将与您深入沟通，了解您的具体需求，并提供最适合的定制解决方案。
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
  </div>
</template>

<script>
import ContactForm from '@/components/ContactForm.vue'

export default {
  name: 'Contact',
  components: {
    ContactForm
  },
  methods: {
    handleSubmitSuccess() {
      // 可以在这里处理表单提交成功后的逻辑
      console.log('表单提交成功');
    }
  }
}
</script>

<style scoped>
.banner {
  padding: 70px 0;
  color: #2C3E50;
  margin-bottom: 40px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  position: relative;
}
.banner-content {
  text-align: center;
  position: relative;
  z-index: 2;
}
.banner-content h1 {
  font-size: 2.8rem;
  margin-bottom: 1rem;
  font-weight: 600;
}
.banner-content p {
  font-size: 1.3rem;
  max-width: 600px;
  margin: 0 auto;
  font-weight: 300;
}

.bg-light {
  background-color: #f8f9fa;
}

.contact-info, .contact-form {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0,0,0,0.05);
  padding: 30px;
  margin-bottom: 30px;
  height: 100%;
}

.contact-info h2, .contact-form h2 {
  margin-bottom: 20px;
  color: #333;
  font-size: 1.8rem;
}

.contact-desc, .form-desc {
  color: #666;
  margin-bottom: 30px;
  line-height: 1.6;
}

.contact-item {
  display: flex;
  margin-bottom: 25px;
}

.contact-item i {
  font-size: 2rem;
  color: #1976D2;
  margin-right: 20px;
  width: 40px;
  text-align: center;
}

.contact-item h3 {
  margin: 0 0 5px;
  font-size: 1.2rem;
  color: #333;
}

.contact-item p {
  margin: 0;
  color: #666;
}

.social-links {
  margin-top: 30px;
}

.social-links h3 {
  margin-bottom: 15px;
  font-size: 1.2rem;
  color: #333;
}

.social-icons {
  display: flex;
  gap: 15px;
}

.social-icon {
  width: 40px;
  height: 40px;
  background-color: #1976D2;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  transition: all 0.3s;
}

.social-icon:hover {
  transform: translateY(-3px);
  background-color: #1565C0;
}

.social-icon i {
  font-size: 1.3rem;
}

.map-container {
  height: 400px;
  border-radius: 8px;
  overflow: hidden;
}

.map-placeholder {
  height: 100%;
  background-color: #e9ecef;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #666;
}

.map-placeholder i {
  font-size: 4rem;
  color: #1976D2;
  margin-bottom: 20px;
}

.map-placeholder p {
  font-size: 1.2rem;
}
</style>
